import s from "qs";
const g = (t) => (a) => t.get(`/tag-metadata/${a}`), o = (t) => (a) => {
  const e = s.stringify(
    {
      limit: a.limit,
      offset: a.offset,
      tagIds: a.tagIds ? a.tagIds : void 0
    },
    { arrayFormat: "comma" }
  );
  return t.get(`/tag-metadata?${e}`, {});
}, i = (t) => (a) => t.post("/tag-metadata", a), m = (t) => (a, e) => t.put(`/tag-metadata/${a}/poisMetadata`, e);
export {
  i as createTagMetadata,
  g as getTagMetadata,
  o as listTagMetadata,
  m as updatePOIMetadata
};
//# sourceMappingURL=index.es496.js.map
